<template>
  <section class="explore-housing">
    <div class="facts grid grid-cols-2">
      <mvtFactCard v-if="avgPrice" icon='home-percent' subtitle='Average home price' info='Source: Based on neighborhood median home prices'>
        {{ avgPrice }}
      </mvtFactCard>
      <mvtFactCard v-if="avgSize" icon='size' subtitle='Average home size' info='Source: Based on neighborhood median home size'>
        {{ avgSize }} sqft
      </mvtFactCard>
    </div>
    <div v-if="!!neighborhood?.relatedListings?.nearby?.length" class="listings nearby">
      <div class="head">
        <div class="f5 text-bold"><a v-if="geo.neighborhoodPath" class="f5 link" :href="`${appUrl}${geo.neighborhoodPath}`">Homes for sale in {{ geo.neighborhood }}</a></div>
      </div>
      <mvtNearby :data="neighborhood.relatedListings.nearby" carousalType="for_sale" />
    </div>
    <div v-if="!!neighborhood?.relatedListings?.rentals?.length" class="listings rental">
      <div class="head">
        <div class="f5 text-bold"><a v-if="geo.neighborhoodPath"  class="link" :href="`${appUrl}${geo.neighborhoodPath}rentals/`">Homes for rent in {{ geo.neighborhood }}</a></div>
      </div>
      <mvtNearby :data="neighborhood.relatedListings.rentals" carousalType="rentals" />
    </div>
    <div v-if="!!neighborhood?.relatedListings?.nearbyNeighborhoods.length" class="listings nearby-neighborhoods">
      <div class="head">
        <div class="f5 text-bold"><a v-if="geo.cityPath" class="link" :href="`${appUrl}${geo.cityPath}`">Homes for sale in {{geo.city}}</a></div>
      </div>
      <mvtNearby :data="neighborhood.relatedListings.nearbyNeighborhoods" carousalType="nearby" />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import mvtFactCard from '@/common/components/mvtfactcard/mvt-factcard.vue';

  export default {
    name: 'exploreHousing',
    props: {
      appUrl: {
        type: String,
        required: true,
      },
      snapshotData: {
        type: Object,
        required: true,
      },
      avgPrice: {
        type: String,
        required: true,
      },
      avgSize: {
        type: String,
        required: true,
      }
    },
    components: {
      mvtNearby,
      mvtFactCard,
    },
    computed: {
      ...mapGetters('neighborhood', ['neighborhood']),
      geo () {
          return this.neighborhood.geo;
      },
    }
  };
</script>

<style lang="scss">
  .explore-housing {
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .mvt-shifter {
      width: 100%;
      padding: 0;
    }
    > .listings {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-top: 2rem;
    }
    > .facts {
      margin-bottom: 3rem;
    }
  }
</style>